<template>
    <div>
        <Panel
            :title="$t('Recording Retention Rules')"
            :add-button="$store.hasRight('ADD_RETENTION_RULES') ? $t('Add') : ''"
            :delete-button="$store.hasRight('DELETE_RETENTION_RULES') && selected.length > 0"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="retentionrules_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Rule Name') }}</th>
                        <th>{{ $t('Object Type') }}</th>
                        <th>{{ $t('Object Values') }}</th>
                        <th>{{ $t('RETENTION_PERIOD') }}</th>
                        <th v-if="$store.hasRight('DELETE_RETENTION_RULES')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="rule in items" @click="(evt) => handleOpen(rule.ruleId, evt)">
                        <td class="primary">
                            {{ rule.name }}
                        </td>
                        <td>{{ objectTypes[rule.objectType] }}</td>
                        <td>{{ rule.objectValues.join(', ') }}</td>
                        <td>
                            {{
                                periods.some((x) => x.periodId === rule.periodId)
                                    ? periods.find((x) => x.periodId === rule.periodId).name
                                    : ''
                            }}
                        </td>
                        <td v-if="$store.hasRight('DELETE_RETENTION_RULES')">
                            <cic-checkbox
                                :value="selected.includes(rule.ruleId)"
                                @click="handleSelected(rule.ruleId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditRetentionRule
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            :periods="periods"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import { showValidationMessage } from '@/utils/Notification';
    import EditRetentionRule from './EditRetentionRule';

    export default {
        name: 'RetentionRules',
        components: {
            Panel,
            EditRetentionRule,
            CicCheckbox,
        },
        mixins: [TableUtils],
        props: {
            periods: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                item: null,
                items: [],
                objectTypes: [this.$t('Outbound presentation CLI'), this.$t('ACCESS_TYPE_1'), this.$t('Export Status')],
                selected: [],
            };
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('retentionrules/delete', { ruleIds: this.selected }, this.loadTable);
            },

            loadTable() {
                load('retentionrules/get', {}, (response) => {
                    this.items = response.rules;
                });
            },

            openForm(ruleId) {
                if (ruleId > 0) {
                    this.item = { ...this.items.find((x) => x.ruleId === ruleId) };
                } else {
                    this.item = {
                        ruleId: null,
                        name: '',
                        objectType: 0,
                        objectValues: [],
                        periodId: null,
                    };
                }
            },

            saveItem() {
                if (!this.item.name || this.item.name.trim() === '') {
                    showValidationMessage('Rule name is a required field');
                    return;
                }

                if (!this.item.periodId) {
                    showValidationMessage('Invalid Retention Period');
                    return;
                }

                if (this.item.objectValues.length === 0) {
                    showValidationMessage('ERROR_NO_OBJECT_VALUES');
                    return;
                }

                let params = {
                    ...this.item,
                    objectValues: JSON.stringify(this.item.objectValues.map((x) => x.trim()).filter((x) => x !== '')),
                };

                save('retentionrule/update', params, this.loadTable);
            },
        },
    };
</script>
